import {mapState, mapMutations, mapActions, mapGetters} from 'vuex'
import {getRecommendedReading} from '../../request/index/index'
// 首页全部数据
export default {
    namespaced: true,
    state: {
        recommendedReadingList: [],
        bannerList: []
    },
    mutations: {
        setReadList (state, payLoad) {
            if (payLoad.success) {
                state.recommendedReadingList = payLoad.data.list.adv_12
            } else {
                console.warn('获取轮播图和推荐列表失败')
            }
        },
        setBannerList (state, payLoad) {
            if (payLoad.success) {
                state.bannerList = payLoad.data.list.adv_2
            } else {
                console.warn('获取轮播图和推荐列表失败')
            }
        }
    },
    actions: {
        getRecommendedReading (context, payLoad) {
            getRecommendedReading(payLoad).then(res => {
                if (parseInt(payLoad.type) === 2) {
                    context.commit('setBannerList', res)
                } else if (parseInt(payLoad.type) === 12) {
                    context.commit('setReadList', res)
                }
            })
        }
    },
    getters: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/index.js